import store from "../store/index";
import ApiHelpers from "../helpers/ApiHelpers";
import {
  INTERACTIONS_REACTION_API,
  INTERACTIONS_COMMENT_API,
  INTERACTIONS_COMMENTS_API,
  INTERACTIONS_PERMISSIONS_API,
} from "../constants/urls";

export const interactionsService = {
  toggleReaction,
  addComment,
  updateComment,
  deleteComment,
  fetchComments,
  setEntityPermissions,
};

async function toggleReaction({ entityType, entityId }) {
  const body = JSON.stringify({ EntityType: entityType, EntityID: entityId });
  const response = await ApiHelpers.makeAPICall(
    `${apiBase()}${INTERACTIONS_REACTION_API}`,
    "POST",
    body,
    true
  );
  return await handleResponse(response);
}

async function addComment({ entityType, entityId, body, attachmentIds = [] }) {
  const requestBody = JSON.stringify({
    EntityType: entityType,
    EntityID: entityId,
    Body: body,
    AttachmentIDs: attachmentIds,
  });
  const response = await ApiHelpers.makeAPICall(
    `${apiBase()}${INTERACTIONS_COMMENT_API}`,
    "POST",
    requestBody,
    true
  );
  return await handleResponse(response);
}

async function updateComment({ id, body, attachmentIds = [] }) {
  const requestBody = JSON.stringify({ ID: id, Body: body, AttachmentIDs: attachmentIds });
  const response = await ApiHelpers.makeAPICall(
    `${apiBase()}${INTERACTIONS_COMMENT_API}/${id}`,
    "PUT",
    requestBody,
    true
  );
  return await handleResponse(response);
}

async function deleteComment(id) {
  const response = await ApiHelpers.makeAPICall(
    `${apiBase()}${INTERACTIONS_COMMENT_API}/${id}`,
    "DELETE",
    null,
    false
  );
  return await handleResponse(response);
}

async function fetchComments({ entityType, entityId, pageSize = 10, nextPageToken = null } = {}) {
  const params = new URLSearchParams();
  params.append("EntityType", entityType);
  params.append("EntityID", entityId);
  if (pageSize) params.append("PageSize", pageSize);
  if (nextPageToken) params.append("NextPageToken", nextPageToken);

  const url = `${apiBase()}${INTERACTIONS_COMMENTS_API}?${params.toString()}`;
  const response = await ApiHelpers.makeAPICall(url, "GET", null, false);
  return await handleEnvelopedListResponse(response);
}

async function setEntityPermissions({ entityType, entityId, isCommentAllowed, isReactionAllowed }) {
  const body = JSON.stringify({
    EntityType: entityType,
    EntityID: entityId,
    IsCommentAllowed: isCommentAllowed,
    IsReactionAllowed: isReactionAllowed,
  });
  const response = await ApiHelpers.makeAPICall(
    `${apiBase()}${INTERACTIONS_PERMISSIONS_API}`,
    "PUT",
    body,
    true
  );
  return await handleResponse(response);
}

// ---------- Helpers ----------

function apiBase() {
  return store.state.appState.apiURL;
}

async function handleResponse(response) {
  try {
    const text = await response.text();
    const body = text ? JSON.parse(text) : null;

    if (!response.ok) {
      return Promise.reject(body?.error || { message: "Request failed." });
    }

    if (body && typeof body === "object" && "status" in body && body.status?.toLowerCase() === "success") {
      return body.payload;
    }
    if (body && typeof body === "object" && "payload" in body) {
      return body.payload;
    }
    return body;
  } catch (parseError) {
    return Promise.reject({ message: "Failed to parse response." });
  }
}

async function handleEnvelopedListResponse(response) {
  try {
    const text = await response.text();
    const body = text ? JSON.parse(text) : null;

    if (!response.ok) {
      return Promise.reject(body?.error || { message: "Request failed." });
    }

    return {
      payload: body?.payload || [],
      nextPageToken: body?.nextPageToken || null,
    };
  } catch (parseError) {
    return Promise.reject({ message: "Failed to parse response." });
  }
}
